import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import login_img from "../../assets/images/login-img.png";

import ApiService from "../../services/ApiService.js";

import { toast } from "react-toastify";
import AuthGuard from "../../components/AuthGuard.jsx";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  // const basePath = process.env.REACT_APP_BASE_PATH;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const clearTalentData = () => {
    const talentData = localStorage.getItem("user");
    if (talentData) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      console.log("Previous talent session cleared");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      clearTalentData();
      const response = await ApiService.request({
        method: "POST",
        url: `/company/login`,
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        let user = data.data.company;
        user.auth_token = data.data.auth_token;
        localStorage.setItem("company", JSON.stringify(data.data.company));
        navigate("/company/dashboard");
      } else {
        toast.error(data.message);
        if (!data.data.phone_verified) {
          localStorage.setItem("company_id", data.data?.company?._id);
          navigate("/company/verify-otp");
        }
      }
      setIsLoader(false);
    } catch (error) {
      // toast.error("Login failed!");
      setIsLoader(false);
    }
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AuthGuard>
        <Header />
        <div className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center position-relative w-100 px-3">
          {/* Logo - top left */}
          {/* <Link to={"/"} className="inter-font position-absolute top-0 start-0 mt-4 ms-4 cursor-pointer">
          <img src={logo} alt="Logo" style={{ height: 50, maxWidth: "100%" }} />
        </Link> */}
          <div
            className="inter-font container px-0"
            style={{ maxWidth: "850px" }}
          >
            <div className="inter-font row g-0 shadow-lg rounded-4 overflow-hidden">
              {/* Left Image */}
              <div className="inter-font col-md-6 d-none d-md-block p-0">
                <img
                  src={login_img}
                  className="inter-font w-100 h-100 object-fit-cover"
                  alt="Login visual"
                  style={{ minHeight: "550px" }}
                />
              </div>
              {/* Login Form */}
              <div className="inter-font col-12 col-md-6 bg-white p-4 p-md-5">
                <form
                  onSubmit={handleSubmit}
                  className="inter-font "
                  style={{ maxWidth: "500px" }}
                >
                  <h2
                    className="inter-font fw-bold mb-1 inter-font"
                    style={{ fontSize: "25px" }}
                  >
                    {t("c_login_title")}
                  </h2>
                  <p
                    className="inter-font text-muted mb-4 inter-font"
                    style={{ fontSize: "16px" }}
                  >
                    {t("c_login_dec")}
                  </p>

                  <div className="inter-font mb-4 inp-login">
                    <label className="inter-font mb-1 inter-font">
                      {t("c_ff_text1")}
                    </label>
                    <input
                      type="email"
                      className="inter-font form-control p-3 inter-font w-100"
                      name="email"
                      placeholder={t("enter_email")}
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      style={{
                        backgroundColor: "#f8f8f8",
                        borderRadius: "8px",
                      }}
                    />
                  </div>

                  <div className="inter-font mb-4 inp-login">
                    <label className="inter-font mb-1 inter-font">
                      {t("c_ff_text2")}
                    </label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="inter-font form-control p-3 inter-font w-100"
                        name="password"
                        value={formData.password}
                        placeholder={t("new_text_17")}
                        onChange={handleInputChange}
                        required
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: "8px",
                          textAlign: isRTL ? "right" : "left",
                          paddingRight: isRTL ? "50px" : "15px",
                          paddingLeft: isRTL ? "15px" : "50px",
                        }}
                        dir={isRTL ? "rtl" : "ltr"}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="position-absolute"
                        style={{
                          top: "50%",
                          [isRTL ? "left" : "right"]: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontSize: "16px",
                          color: "#888",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    <div className="mt-3">
                      <Link
                        to={"/company/forgot-password"}
                        style={{
                          color: "#E46A56",
                          background: "none",
                          fontSize: "14px",
                        }}
                        className="text-decoration-underline ms-1"
                      >
                        {t("c_ff_text5")}
                      </Link>
                    </div>
                  </div>

                  <div className="inter-font d-flex flex-column  justify-content-between align-items-start  gap-3">
                    <button
                      type="submit"
                      className="inter-font btn text-white inter-font"
                      style={{
                        backgroundColor: "#ff5722",
                        padding: "10px 30px",
                        borderRadius: "20px",
                        fontSize: "18px",
                        whiteSpace: "nowrap",
                      }}
                      disabled={isLoader}
                    >
                      {isLoader ? `${t("new_text_18")}` : `${t("c_login_btn")}`}
                    </button>

                    <p
                      className="inter-font mb-0 inter-font"
                      style={{ fontSize: "14px" }}
                    >
                      {t("c_login_info")}
                      <Link
                        to="/company"
                        className="inter-font   text-decoration-underline ms-1"
                        style={{ cursor: "pointer", color: "#FF6237" }}
                      >
                        {t("h_s4_c2_title")}
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </AuthGuard>
    </>
  );
};

export default Login;
